import { format } from 'date-fns';
import type { CampaignLead } from '../../types/campaignLead';
import { Badge } from '../ui';

interface CampaignLeadDetailsProps {
  campaignLead: CampaignLead;
}

function CampaignLeadDetails({ campaignLead }: CampaignLeadDetailsProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
            Lead / Contato
          </h3>
          <p className="text-base text-gray-900 dark:text-white">
            {campaignLead.lead_name || `Lead #${campaignLead.lead_id}`}
          </p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
            Campanha / Ticket
          </h3>
          <p className="text-base text-gray-900 dark:text-white">
            {campaignLead.campaign_name || `Campanha #${campaignLead.campaign_id}`}
          </p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Vendedor</h3>
          <p className="text-base text-gray-900 dark:text-white">
            {campaignLead.representative_name || '-'}
          </p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Score</h3>
          <p className="text-base text-gray-900 dark:text-white">
            {campaignLead.score !== null && campaignLead.score !== undefined
              ? campaignLead.score
              : '-'}
          </p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Estágio</h3>
          <div>
            <Badge variant="info">{campaignLead.stage}</Badge>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Tipo</h3>
          <div>
            <Badge variant="default">{campaignLead.type}</Badge>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Ação</h3>
          <div>
            <Badge variant={campaignLead.action === 'nenhuma' ? 'default' : 'warning'}>
              {campaignLead.action}
            </Badge>
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
            ID do Ticket
          </h3>
          <p className="text-base text-gray-900 dark:text-white">{campaignLead.ticket_id || '-'}</p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
            Último Resumo
          </h3>
          <p className="text-base text-gray-900 dark:text-white">
            {campaignLead.last_resume
              ? format(new Date(campaignLead.last_resume), 'dd/MM/yyyy HH:mm')
              : '-'}
          </p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Status</h3>
          <div>
            <Badge variant={campaignLead.archived_at ? 'default' : 'success'}>
              {campaignLead.archived_at ? 'Arquivado' : 'Ativo'}
            </Badge>
          </div>
        </div>
      </div>

      {campaignLead.notes && (
        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Observações</h3>
          <p className="text-base text-gray-900 dark:text-white whitespace-pre-wrap">
            {campaignLead.notes}
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4 border-t border-gray-200 dark:border-gray-700">
        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Criado em</h3>
          <p className="text-base text-gray-900 dark:text-white">
            {format(new Date(campaignLead.created_at), 'dd/MM/yyyy HH:mm')}
          </p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
            Atualizado em
          </h3>
          <p className="text-base text-gray-900 dark:text-white">
            {format(new Date(campaignLead.updated_at), 'dd/MM/yyyy HH:mm')}
          </p>
        </div>

        {campaignLead.archived_at && (
          <div>
            <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
              Arquivado em
            </h3>
            <p className="text-base text-gray-900 dark:text-white">
              {format(new Date(campaignLead.archived_at), 'dd/MM/yyyy HH:mm')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default CampaignLeadDetails;
